export default __webpack_public_path__ + "media/images/banner/banner-23-f09153da46551f6f35d816db894b566b.jpg";